registerComponent("sections/history-timeline", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Os dois carrosséis da linha do tempo, que em 2020 eram dois slick amarrados
 * por `asNavFor` — a fita de anos e o cartão do evento:
 *
 * · ANOS: `slidesToShow: 7`, `slidesToScroll: 1`, `focusOnSelect: true` (no
 *   celular, `3` com `variableWidth`).
 * · EVENTOS: `fade: true` fora do celular e, dentro dele, `fade: false` com
 *   `centerMode` e `variableWidth`. As duas setas do `.wrap-timeline-years`
 *   pertenciam a ESTE slider, não ao dos anos.
 *
 * Os dois viram `Asa.trilho` em `modo: 'troca'`, cada um com o outro em
 * `sincronizarCom` — é o `asNavFor`, e não há laço porque quem já está no
 * índice pedido não repete.
 *
 * ⚠️ Por que `troca` NOS DOIS, e não rolagem na fita de anos:
 *
 * o modo rolagem tira o índice ativo da POSIÇÃO DE ROLAGEM, e a fita de anos
 * não rola quando os anos cabem todos na janela — são sete anos no
 * `config/pages/history.php` e `slidesToShow: 7`. O ativo ficaria preso no
 * primeiro, o ano não acompanharia a seta e clicar num ano não faria nada
 * (medido: `ano=0` depois de `evento=1`). Em `troca` o ativo é de quem o
 * marca, e funciona nas duas larguras.
 *
 * ⚠️ O que o `Asa.trilho` não cobre, e por isso está aqui: em `troca` nada
 * rola, e no celular as duas listas SÃO tiras que rolam com o dedo (a de anos
 * porque sete não cabem em 250rem, a de eventos por causa do `centerMode`).
 * `tiraSincronizada` liga as duas pontas que faltam — levar o item ativo para
 * dentro da janela quando ele muda, e trocar o ativo quando o dedo rola. As
 * duas se reconhecem pelo CSS (`scrollWidth > clientWidth` só é verdade onde a
 * tira existe), nunca por `matchMedia`: o degrau mora num lugar só, a folha.
 */

const anosEl = component.querySelector('.timeline-history-years');
const eventosEl = component.querySelector('.timeline-history-events');

/**
 * A posição de um item dentro do conteúdo rolável, sem depender de
 * `offsetParent` — a mesma conta do `Asa.trilho`.
 *
 * @param {HTMLElement} trilho
 * @param {HTMLElement} item
 * @returns {number}
 */
function esquerdaDe(trilho, item) {
    return item.getBoundingClientRect().left - trilho.getBoundingClientRect().left + trilho.scrollLeft;
}

/**
 * @param {HTMLElement} trilho
 * @returns {HTMLElement[]}
 */
function itensDe(trilho) {
    return Array.from(trilho.querySelectorAll(':scope > .timeline-item'));
}

/**
 * As duas pontas que o modo `troca` não tem, para onde o CSS fez tira.
 *
 * @param {HTMLElement} el - o elemento que rola
 * @param {{ irPara: (i: number) => void, indice: () => number }} trilho
 * @param {'start'|'center'} alinhamento
 * @returns {void}
 */
function tiraSincronizada(el, trilho, alinhamento) {
    /** Fora do celular os itens cabem na janela (ou estão empilhados). */
    const rolavel = () => el.scrollWidth - el.clientWidth > 2;

    /** O ponto do item que encosta no ponto de referência da janela. */
    const ancoraDe = (item) => (alinhamento === 'center' ? item.offsetWidth / 2 : 0);
    const ancoraDaJanela = () => (alinhamento === 'center' ? el.clientWidth / 2 : 0);

    let vindoDaRolagem = false;
    let agendado = false;

    el.addEventListener('trilho:mudou', function (evento) {
        if (vindoDaRolagem || !rolavel()) {
            return;
        }

        const item = itensDe(el)[evento.detail.indice];

        if (!item) {
            return;
        }

        el.scrollTo({
            left: esquerdaDe(el, item) + ancoraDe(item) - ancoraDaJanela(),
            behavior: Asa.movimentoPermitido() ? 'smooth' : 'auto',
        });
    });

    el.addEventListener('scroll', function () {
        if (agendado) {
            return;
        }

        agendado = true;

        requestAnimationFrame(function () {
            agendado = false;

            if (!rolavel()) {
                return;
            }

            const referencia = el.scrollLeft + ancoraDaJanela();
            let indice = 0;
            let menor = Infinity;

            itensDe(el).forEach(function (item, i) {
                const distancia = Math.abs(esquerdaDe(el, item) + ancoraDe(item) - referencia);

                if (distancia < menor) {
                    menor = distancia;
                    indice = i;
                }
            });

            if (indice !== trilho.indice()) {
                /*
                 | O `irPara` do modo troca é síncrono: troca a classe, atualiza
                 | e emite `trilho:mudou` antes de devolver. A bandeira impede
                 | que o ouvinte acima lute com o dedo de quem está rolando.
                 */
                vindoDaRolagem = true;
                trilho.irPara(indice);
                vindoDaRolagem = false;
            }
        });
    }, { passive: true });
}

if (anosEl && eventosEl) {
    const eventos = Asa.trilho(eventosEl, {
        itens: '.timeline-item',
        modo: 'troca',
        anterior: component.querySelector('.wrap-timeline-years .slick-prev'),
        proximo: component.querySelector('.wrap-timeline-years .slick-next'),
    });

    const anos = Asa.trilho(anosEl, {
        itens: '.timeline-item',
        modo: 'troca',
        selecionarAoClicar: true,
        sincronizarCom: eventos,
    });

    eventos.sincronizar(anos);

    tiraSincronizada(anosEl, anos, 'start');
    tiraSincronizada(eventosEl, eventos, 'center');
}

});
